export default{
  userInfo:{
      path: '/report/userInfo',
      name: 'userInfo',
      component: () => import('./userInfo.vue')
  },
  workflowInfo:{
      path: '/report/workflowInfo',
      name: 'workflowInfo',
      component: () => import('./workflowInfo.vue')
  },
  workflowovertime:{
      path: '/report/workflowovertime',
      name: 'workflowovertime',
      component: () => import('./workflowovertime.vue')
  },
  processefficiency:{
    path: '/report/processefficiency',
    name: 'processefficiency',
    component: () => import('./processefficiency.vue')
  },
  approvalInfo:{
    path: '/report/approvalInfo',
    name: 'approvalInfo',
    component: () => import('./approvalInfo.vue')
  }
}